var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoolLines1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 9,
    viewBox: "0 0 96 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4C0.723858 4 0.5 4.22386 0.5 4.5C0.5 4.77614 0.723858 5 1 5V4ZM95.8536 4.85355C96.0488 4.65829 96.0488 4.34171 95.8536 4.14645L92.6716 0.964466C92.4763 0.769204 92.1597 0.769204 91.9645 0.964466C91.7692 1.15973 91.7692 1.47631 91.9645 1.67157L94.7929 4.5L91.9645 7.32843C91.7692 7.52369 91.7692 7.84027 91.9645 8.03553C92.1597 8.2308 92.4763 8.2308 92.6716 8.03553L95.8536 4.85355ZM1 5H48.25V4H1V5ZM48.25 5H95.5V4H48.25V5Z",
    fill: "#D0D0D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoolLines1);
export default __webpack_public_path__ + "static/media/pool-lines-1.49283189c05f204497cb67502cb53c14.svg";
export { ForwardRef as ReactComponent };